import axios from 'axios';
import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import undefsafe from 'undefsafe';
import Button from '../../../components/CustomButton/CustomButton';
import Upload from '../../../lib/upload';
import * as K from '../redux/SalesConstants';
import numeral from 'numeral';

class operatorsPaymentSaleAdd extends Component {
  constructor(props) {
    super(props);
    this.paymentDefault = {
      concept: '',
      cost: '',
      date: moment().format('LLL'),
      files: [],
      coupon: '',
    };

    this.formDataDefault = {
      concept: '',

      nationalCurrency: '',
      price: '',
      date: '',
      operator: '',
      images: '',
      files: [],
      list: [this.paymentDefault],
      totalPayed: 0,
    };

    this.state = {
      formData: this.formDataDefault,
      optionsSelect: {
        operators: [],
      },
    };
  }

  componentWillMount() {
    this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    var newForm = nextProps.Sales.dataToEdit.operatorsPayment;
    if (newForm !== undefined && JSON.stringify(newForm) !== '{}') {
      this.state.edit = newForm;
      this.setState({
        formData: newForm,
      });
    }
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });
    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      formData: this.formDataDefault,
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'operatorsPayment',
    });
  };

  onAdd = () => {
    if (this.formGeneral.reportValidity()) {
      if (this.state.edit !== undefined) {
        let newListSaved = this.state.formData.list.map((item) => {
          if (item.cost !== 0 && item.cost !== '') {
            item.saved = true;
            return item;
          }

          return item;
        });
        var newFormData = immutable.set(
          this.state.formData,
          'list',
          newListSaved
        );

        this.props.dispatch({
          type: K.UPDATE_OPERATORSPAYMENTS,
          payload: {
            data: {
              value: newFormData,
              index: this.props.Sales.indexPaymentToEdit,
            },
          },
        });
        this.props.dispatch({
          type: K.CLOSE_MODAL_ADD,
          payload: 'operatorsPayment',
        });
      } else {
        this.props.dispatch({
          type: K.ADD_OPERATORSPAYMENTS,
          payload: this.state.formData,
        });
        this.props.dispatch({
          type: K.CLOSE_MODAL_ADD,
          payload: 'operatorsPayment',
        });
      }

      this.setState({
        formData: this.formDataDefault,
      });
    }
  };

  addOption = () => {
    var newFormData = immutable.push(
      this.state.formData,
      'list',
      this.paymentDefault
    );
    this.setState({
      formData: newFormData,
    });
  };

  removeOption = (index) => {
    var newFormData = immutable.del(this.state.formData, ['list', index]);
    this.setState({
      formData: newFormData,
    });
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);
    this.setState({
      formData: newFormData,
    });
  };

  onChangeSum = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    let listSum = 0;
    newFormData.list.map(function (item) {
      listSum = numeral(listSum + Number(item.cost)).format('0.00') - 0;
    });

    if (listSum > Number(newFormData.nationalCurrency).toFixed(2)) {
      alert('Cantidad mayor al total');
      newFormData = immutable.set(newFormData, path, '');
      listSum = numeral(listSum - Number(value)).format('0.00') - 0;
    } else {
      newFormData = immutable.set(newFormData, 'totalPayed', listSum);
    }

    this.setState({
      formData: newFormData,
    });
  };
  render() {
    var { Sales } = this.props;
    const { formData, optionsSelect } = this.state;
    if (formData.list === undefined) {
      formData.list = [this.paymentDefault];
    }
    return (
      <div>
        <Modal
          open={undefsafe(Sales.modalAddStatus, 'operatorsPayment') || false}
          onClose={this.onCloseModal}
          styles={{ modal: { width: '100%' } }}
          closeOnOverlayClick={false}
        >
          <div>
            <form
              ref={(ref) => {
                this.formGeneral = ref;
              }}
              // onSubmit={this.handledCompleteForm}
              id="Payments"
            >
              <Grid fluid>
                <Row>
                  <Col md={12}>
                    <h5>Agregar pago a operador</h5>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="operator" style={{ fontWeight: '400' }}>
                        OPERADOR
                      </label>
                      <Select
                        disabled
                        validate
                        placeholder="-- Seleccionar"
                        name="operator"
                        required
                        value={formData.operator}
                        options={optionsSelect.operators}
                        onChange={(value) => {
                          if (value) {
                            this.onChange('operator', value.value);
                          } else {
                            this.onChange('operator', '');
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="form-group">
                      <label
                        htmlFor="nationalCurrency"
                        style={{ fontWeight: '400' }}
                      >
                        MONTO (MXN)
                      </label>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        id="nationalCurrency"
                        name="nationalCurrency"
                        value={numeral(formData.nationalCurrency).format(
                          '$0,00.00'
                        )}
                        onChange={(event) =>
                          this.onChange('nationalCurrency', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="coupon" style={{ fontWeight: '400' }}>
                        CÓDIGO DE CUPÓN
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="coupon"
                        name="coupon"
                        value={formData.coupon}
                        onChange={(event) =>
                          this.onChange('coupon', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <Upload
                        label={'ADJUNTAR CUPÓN'}
                        files={formData.files.length > 0 ? formData.files : []}
                        directory={'packs'}
                        bucket={'loopback-rsviajes'}
                        multiple={true}
                        onChange={(files) => {
                          this.onChange('files', files);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <h5>Listado de pagos</h5>
                    <strong>
                      Total Pagado:{' '}
                      {numeral(this.state.formData.totalPayed).format(
                        '$0,00.00'
                      )}
                    </strong>
                  </Col>
                </Row>
                <Row>
                  <hr />
                  {formData.list.map((option, indexOption) => (
                    <div key={indexOption}>
                      <Row>
                        <Col md={1} />
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              htmlFor="concept"
                              style={{ fontWeight: '400' }}
                            >
                              CONCEPTO
                            </label>
                            <input
                              required
                              type="text"
                              className="form-control"
                              disabled={formData.list[indexOption].saved}
                              value={formData.list[indexOption].concept}
                              onChange={(event) =>
                                this.onChange(
                                  ['list', indexOption, 'concept'],
                                  event.target.value
                                )
                              }
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label htmlFor="cost" style={{ fontWeight: '400' }}>
                              CANTIDAD
                            </label>
                            <input
                              required
                              type="number"
                              min="0"
                              step="any"
                              className="form-control"
                              id="cost"
                              disabled={formData.list[indexOption].saved}
                              value={formData.list[indexOption].cost}
                              onChange={(event) =>
                                this.onChangeSum(
                                  ['list', indexOption, 'cost'],
                                  event.target.value
                                )
                              }
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label htmlFor="cost" style={{ fontWeight: '400' }}>
                              Fecha
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="cost"
                              disabled={formData.list[indexOption].saved}
                              value={moment(
                                formData.list[indexOption].date
                              ).format('YYYY-MM-DD')}
                              required
                              onChange={(event) =>
                                this.onChange(
                                  ['list', indexOption, 'date'],
                                  event.target.value
                                )
                              }
                            />
                          </div>
                        </Col>
                        <Col md={1} style={{ marginTop: 25 }}>
                          {this.state.formData.list.length - 1 ===
                          indexOption ? (
                            <Button bsStyle="primary" onClick={this.addOption}>
                              {' '}
                              +{' '}
                            </Button>
                          ) : (
                            <span> </span>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col md={1} />
                        <Col md={10}>
                          <div className="form-group">
                            <Upload
                              label={'ADJUNTAR EVIDENCIA'}
                              files={
                                formData.list[indexOption].files !== undefined
                                  ? formData.list[indexOption].files
                                  : []
                              }
                              directory={'operators'}
                              bucket={'loopback-rsviajes'}
                              multiple={true}
                              onChange={(files) => {
                                this.onChange(
                                  ['list', indexOption, 'files'],
                                  files
                                );
                              }}
                            />
                            <input
                              style={{
                                height: 1,
                                padding: 0,
                                margin: 0,
                                border: 0,
                                color: 'white',
                              }}
                              required
                              type="text"
                              id="hidden"
                              value={formData.list[indexOption].files}
                            />
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </div>
                  ))}
                  <hr />
                </Row>

                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button
                        bsStyle="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.onCloseModal}
                      >
                        Regresar
                      </Button>
                      <Button bsStyle="primary" fill onClick={this.onAdd}>
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(
  operatorsPaymentSaleAdd
);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/operatorsPaymentSaleAdd.js